<template>
  <div class="container">
    

    <van-row>
        <van-col span="16">
          <div class="row">
            <div class="t1">可提现金额：</div>
            <div class="t2" style="color: red">
              {{ this.$store.state.balance }}
            </div>
          </div>
        </van-col>
        <van-col span="3">
          <span class="btn" @click="toWithdraw">去提现</span>
        </van-col>
        <van-col span="5">
          <span class="btn" @click="showCashDetail">提现明细</span>
        </van-col>
      </van-row>

      <van-row style="margin-top: 12px;">
        <van-col span="12">
          <span class="btn2" @click="showInviteDialog">团员邀请二维码</span>
        </van-col>
        <van-col span="12">
          <span class="btn2" @click="toAgent">升级代理商</span>
        </van-col>
        <van-col span="12">
          <span v-if="false" class="btn2" @click="toInvite">升级代理商付款链接</span>
        </van-col>
      </van-row>


      <div
      style="text-align: left; margin-top: 20px; color: black; font-weight: 700"
    >
      团队情况:
    </div>
    <div class="box">
      <van-row style="margin-top: 20px">
        <van-col span="8" class="center">
          <div class="column">
            <div class="t1">团队人数</div>
            <div class="t2 mt15">{{ inviteData.num }}人</div>
          </div>
        </van-col>

        <van-col span="8" class="center">
          <div class="column">
            <div class="t1">充值人数</div>
            <div class="t2 mt15">{{ incomeData.totalRechargeCount }}人</div>
          </div>
        </van-col>

        <van-col span="8" class="center">
          <div class="column">
            <div class="t1">代理商人数</div>
            <div class="t2 mt15">{{ inviteData.agentNum }}人</div>
          </div>
        </van-col>
      </van-row>

      <van-row style="margin-top: 20px">
        <van-col span="12" class="center">
          <div class="column">
            <div class="t1">直推人数</div>
            <div class="t2 mt15">{{ inviteData.inviteNum }}人</div>
          </div>
        </van-col>

        <van-col span="12" class="center">
          <div class="column">
            <div class="t1">直推付费人数</div>
            <div class="t2 mt15">{{ inviteData.inviteOrderNum }}人</div>
          </div>
        </van-col>
      </van-row>
      <van-row style="margin-top: 20px">
        <van-col span="8" class="center">
          <div class="column">
            <span class="t1">今日邀请人数</span>
            <div class="t2 mt15">{{ inviteData.dayNum }}人</div>
          </div>
        </van-col>
        <van-col span="8" class="center">
          <div class="column">
            <span class="t1">本周邀请数</span>
            <div class="t2 mt15">{{ inviteData.weekNum }}人</div>
          </div>
        </van-col>

        <van-col span="8" class="center">
          <div class="column">
            <span class="t1">本月邀请人数</span>
            <div class="t2 mt15">{{ inviteData.monthNum }}人</div>
          </div>
        </van-col>
      </van-row>

      <van-row style="margin-top: 20px">
        <van-col span="8" class="center">
          <div class="column">
            <span class="t1">今日直推邀请人数</span>
            <div class="t2 mt15">{{ inviteData.dayInviteNum }}人</div>
          </div>
        </van-col>
        <van-col span="8" class="center">
          <div class="column">
            <span class="t1">本周直推邀请人数</span>
            <div class="t2 mt15">{{ inviteData.weekInviteNum }}人</div>
          </div>
        </van-col>

        <van-col span="8" class="center">
          <div class="column">
            <span class="t1">本月直推邀请人数</span>
            <div class="t2 mt15">{{ inviteData.monthInviteNum }}人</div>
          </div>
        </van-col>
      </van-row>

      <van-row style="margin-top: 20px">
        <van-col span="12" class="center">
          <div class="column">
            <div class="t1">直推未登录人数</div>
            <div class="t2 mt15">{{ inviteData.directNoLoginNum }}人</div>
          </div>
        </van-col>

        <van-col span="12" class="center">
          <div class="column">
            <div class="t1">直推无点数消耗人数</div>
            <div class="t2 mt15">{{ inviteData.directNoPointNum }}人</div>
          </div>
        </van-col>
      </van-row>
    </div>

    <div
      style="text-align: left; color: black; font-weight: 700; margin-top: 10px"
    >
      收益情况：
    </div>
    <div class="box">
     
      <van-row style="margin-top: 10px">
        <van-col span="12" class="center">
          <div class="column">
            <div class="row">
              <div class="t1">总计充值金额</div>
              <img src="../../assets/tips.png" class="tips" alt="" @click="showTips('累计获得的收益金额')" />
            </div>

            <div class="t2 mt15">{{ incomeData.totalRecharge }}元</div>
          </div>
        </van-col>
        <van-col span="12" class="center">
          <div class="column">
            <div class="row">
              <div class="t1">总佣金</div>
              <img src="../../assets/tips.png" class="tips" alt="" @click="showTips('今日预估获得的收益金额')" />
            </div>
            <div class="t2 mt15">{{ incomeData.totalCommission }}元</div>
          </div>
        </van-col>
      </van-row>

      <van-row style="margin-top: 10px">
        <van-col span="8" class="center">
          <div class="column">
            <div class="row">
              <div class="t1">今日充值金额</div>
              <img src="../../assets/tips.png" class="tips" alt="" @click="showTips('未结算订单的总金额')"/>
            </div>
            <div class="t2 mt15">{{ incomeData.dayRecharge }}元</div>
          </div>
        </van-col>
        <van-col span="8" class="center" >
          <div class="column">
            <div class="row">
              <div class="t1">本周充值金额</div>
              <img src="../../assets/tips.png" class="tips" alt="" @click="showTips('累计提现金额')"/>
            </div>
            <div class="t2 mt15">{{ incomeData.weekRecharge }}元</div>
          </div>
        </van-col>

        <van-col span="8" class="center">
          <div class="column">
            <div class="row">
              <div class="t1">本月充值金额</div>
              <img src="../../assets/tips.png" class="tips" alt="" @click="showTips('累计提现金额')"/>
            </div>
            <div class="t2 mt15">{{ incomeData.monthRecharge }}元</div>
          </div>
        </van-col>

      </van-row>

      <van-row style="margin-top: 20px">
        <van-col span="8" class="center">
          <div class="column">
            <div class="row">
              <div class="row">
                <div class="t1">今日佣金</div>
                <img src="../../assets/tips.png" class="tips" alt="" @click="showTips('本周预估获得的收益金额')"/>
              </div>
            </div>
            <div class="t2 mt15">{{ incomeData.dayCommission }}元</div>
          </div>
        </van-col>
        <van-col span="8" class="center">
          <div class="column">
            <div class="row">
              <div class="t1">本周佣金</div>
              <img src="../../assets/tips.png" class="tips" alt="" @click="showTips('本月预估获得的收益金额')"/>
            </div>
            <div class="t2 mt15">{{ incomeData.weekCommission }}元</div>
          </div>
        </van-col>

        <van-col span="8" class="center">
          <div class="column">
            <div class="row">
              <div class="t1">本月佣金</div>
              <img src="../../assets/tips.png" class="tips" alt="" @click="showTips('上月预估获得的收益金额')"/>
            </div>
            <div class="t2 mt15">{{ incomeData.monthCommission }}元</div>
          </div>
        </van-col>
      </van-row>
    </div>

    <cashDetail
      :show="cashDetailShow"
      @close="cashDetailShow = false"
    ></cashDetail>
    <inviteDialog :show="inviteDialogShow" @close="inviteDialogShow=false"></inviteDialog>
  </div>
</template>

<script>
import cashDetail from "../../components/cashDetail.vue";
import inviteDialog from "../../components/inviteDialog.vue"
import {Toast } from "vant";
export default {
  components: {
    cashDetail,
    inviteDialog
  },
  data() {
    return {
      inviteDialogShow:false,
      teamSellShow: false,
      teamIncomeShow: false,
      directInviteShow: false,
      thirdInviteShow: false,
      cashDetailShow: false,
      incomeData: {},
      inviteData: {},
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loadIncome();
      this.loadInvite();
      this.loadAccount();
    },

    showTips(tips){
      Toast(tips)
    },
    loadAccount(){
      this.$request.GET({
        url:'agent/account',
        success:(obj)=>{
          this.$store.commit('setBalance',obj.balance)
        }
      })
    },
    loadIncome() {
      this.$request.GET({
        url: "agent/recharge",
        success: (obj) => {
          this.incomeData = obj;
        },
      });
    },
    loadInvite() {
      this.$request.GET({
        url: "agent/group",
        success: (obj) => {
          this.inviteData = obj;
        },
      });
    },
    
    toWithdraw() {
      this.$router.push({
        name: "withdraw",
      });
    },

    toInvite(){
      this.$router.push({
        name:'invite'
      })
    },
    //升级代理商
    toAgent(){
      this.$router.push({
        name:'upagent'
      })
    },
    showCashDetail() {
      this.cashDetailShow = true;
    },
    showInviteDialog(){
      this.inviteDialogShow = true;
    }
  },
};
</script>

<style scoped lang="less">
@import url("vant/lib/index.less");
.container {
  padding-bottom: 56px;;
  font-size: 14px;
  padding-top: 20px;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  flex-direction: column;
  background-color: #ededed;
}
.column {
  display: flex;
  flex-direction: column;
  width: fit-content;
}
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.row_cent{
  align-items: center;
}
.column_cent{
  justify-content: center;
}
.center {
  display: flex;
  justify-content: center;
}

.left {
  align-items: start;
}

.box {
  font-family: simhei;
  margin-top: 8px;
  padding-top: 10px;
  padding-bottom: 20px;
  background-image: url("../../assets/bg2.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.mt15 {
  margin-top: 6px;
}

.btn {
  color: #36a732;
  text-decoration: underline;
  font-size: 12px;
  display: flex;
  align-items: flex-end;
}

.btn2 {
  color: #000;
  text-decoration: underline;
  font-size: 14px;
}


.t1 {
  color: black;
  font-size: 14px;
  // text-align: left;
  font-weight: 700;
}
.t2 {
  color: #666;
  font-weight: 600;
  font-size: 14px;
  // text-align: left;
}

.tips {
  margin-left: 4px;
  width: 16px;
  height: 16px;
  display: none;
}
</style>